import NetworkService from '../components/general/NetworkService'
import * as config from '../components/config'
import { setGeneralMessage, setShouldLogout } from './global/globalDataSlice'
import { openUanatacaDialog } from './utilities/utilitySlice'
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setShouldMakeBasicAccountPaymentVoid } from './basicAccount/basicAccountSlice';
import { setIsSelphIDCompleted, setIsSelphiCompleted } from './utilities/utilitySlice';

const sendRequest = (payload) => {
  return new Promise((resolve, reject) => {
    NetworkService.post(
      payload.baseUrlKey === 'auth' ? config.default.apiUrls.primaryUserAuth : (payload.baseUrlKey === 'services' ? config.default.apiUrls.primaryServices : (payload.baseUrlKey === 'p2p' && config.default.apiUrls.primaryP2P)),
      payload.endpoint,
      payload.request,
      (status, data) => {
        if (status === 200) {
          resolve({ request: payload.request, response: data, endpoint: payload.endpoint })
        }
        else {
          reject(status)
          //window.location.reload()
        }

      }).catch((err) => { console.log(err) })
  })
}

const requiredLogout = (errorMsg, thunkApi) => {
  // if(errorMsg === "Sesioni juaj ka skaduar, ju lutem hyni përsëri.")
  // {
  //   thunkApi.dispatch(setShouldLogout(true))
  // }
  if (errorMsg.includes('hyni sërisht') || errorMsg.includes('hyni përsëri')) {
    thunkApi.dispatch(setShouldLogout(true))
  } //SHOULD BE FIXED
}

const cancelBasicAccountTransaction = (payload, thunkApi) => {
  var accountType = thunkApi.getState().userInfo.accountType
  if (accountType === 3) {
    if (payload.endpoint ===
      (
        'OSHEE/ConfirmTransaction' ||
        'Penalty/ConfirmTransaction' ||
        'QEZHEF/ConfirmTransaction' ||
        'DIGICOM/ConfirmTransaction' ||
        'Abissnet/ConfirmTransactionAbissnet' ||
        'ALBTELECOM/ConfirmTransactionAlbtelecom' ||
        'UK/ConfirmTransactionUK' ||
        'ASBS/ConfirmVodafoneInvoices' ||
        'ASBS/ConfirmVodafoneTopUPMNO' ||
        'DPTTV/ConfirmTransactionTaxesTirana' ||
        'ASBS/ConfirmASBSTopUPMNO' ||
        'DGA/ConfirmTransaction' ||
        'Eagle/ConfirmTransaction' ||
        'ASBS/ConfirmONEInvoices' 
      )) {
      console.log('payment canceled')
      thunkApi.dispatch(setShouldMakeBasicAccountPaymentVoid(true))
    }
  }
}

const displayUanataca = (payload, thunkApi, data) => {
  let endpointArr = [
      'ASBS/StartVodafoneTopUPMNO',
      'ASBS/StartVodafoneInvoices',
      'OSHEE/StartTransaction',
      'Penalty/StartTransaction',
      'QEZHEF/StartTransaction',
      'DIGICOM/StartTransaction',
      'Abissnet/StartTransactionAbissnet',
      'ALBTELECOM/StartTransactionAlbtelecom',
      'UK/StartTransactionUK',
      'TAKSAVENDORE/StartTransactionTaxes',
      'StartTransactionSHU',
      'StartCardsOnFile',
      'TAKSAVENDORE/StartTransactionTaxes',
      'DPTTV/StartTransactionTaxesTirana',
      'ASBS/StartASBSTopUPMNO',
      'DGA/StartOTTActivation',
      'DGA/StartTransactionOTT',
      'DGA/StartTransaction',
      'startCreditCardPayment',
      'Eagle/StartOfferEagle',
      'Eagle/StartTransaction',
      'CreditBalance',
      'StartIPE2IPE',
      'DirectDebit/CreditAccount',
      'ASBS/StartONEInvoices',
      'Kredo/StartTransactionKredo',
      'NOA/StartNoaLoanToPay',
      'FshatiSOS/StartTransactionFshatiSos',
      'SigurimeMotorrike/GetPremiumForPolicy',
      'Firstcom/StartTransactionFirstcom'
  ]

  if (endpointArr.includes(payload.endpoint) && data.response.code === 2 && thunkApi.getState().userInfo.accountType === 1) {
      thunkApi.dispatch(sendGeneralRequest({ request: { token: thunkApi.getState().globalData.token }, baseUrlKey: "services", endpoint: "CheckFacePhi" })).then(response => {
        if (response.payload.response.success && response.payload.response.uanatacaMandatory){
          thunkApi.dispatch(openUanatacaDialog())
        }
      })
    }  
}

const handleFacephiApi = (payload, thunkApi, data) => { 
    let endpointArr = [ 
      'Onboarding/PostPassiveLiveness',
      'Onboarding/AuthenticateFacial'
    ]
    
    if(endpointArr.includes(payload.endpoint)) { 
      thunkApi.dispatch(setIsSelphiCompleted(data.response.success))
      thunkApi.dispatch(setIsSelphIDCompleted(data.response.success))
    }
}

export const sendGeneralRequest = createAsyncThunk(
  'generalRequest/sendGeneralRequest',
  async (payload, thunkApi) => {
    const data = await sendRequest(payload)
    // console.log({request:payload, response:data.response})
    if (data.response.success === false || data.response.Success === false) {
      displayUanataca(payload, thunkApi, data)
      handleFacephiApi(payload, thunkApi, data)
      cancelBasicAccountTransaction(payload, thunkApi)

      const message = data.response.errorMsg === undefined ? data.response.Message : data.response.errorMsg
      thunkApi.dispatch(setGeneralMessage({ type: 'error', message: message }))
      requiredLogout(message, thunkApi)
      return payload.endpoint === "Onboarding/StatusDocumentValidation" ? data : Promise.reject()
    }
    else {
      return data
    }
  }
);